<template>
   <div class="edit-log-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form"   :model="params" :rules="rules" label-width="80px" >
        <el-form-item label="备注:" prop="remarks">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="params.remarks"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'

export default {
  data() {
    return {
      flag: false,
      title: '',
      id: '',
      dialogVisible: false,
      params: {
        remarks: '',
      },
      // 备注验证
      rules: {
        remarks: [
          { required: true, message: '请输入备注', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
      // this.params = {
      //   remarks: ''
      // }
    },
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.flag = true
          if (this.title === '编辑管理员操作日志') {
            this.editLog()
          } 
        } else {
          return false
        }
        this.$refs['form'].resetFields();
      })
    },
    // 编辑日志
    editLog() {
      let params = {
        id: this.id,
        remarks: this.params.remarks
      }
      API.editAdminLog(params).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '管理员操作日志修改成功',
            type: 'success'
          })
          this.$emit('handlerCtrLog')
        }else {
          this.$message.error(' 管理员操作日志修改失败！');
        }
        this.flag = false
        this.handleClose()
      })
       .catch(() => {
         this.flag = false
          this.handleClose()
       })
    },
    open(type,data) {
      this.dialogVisible = true
      if(type === 'edit') {
        this.title = '编辑管理员操作日志'
        this.id = data.id
        this.params.remarks = data.remarks

      }
    }
  },

  
}
</script>
<style scoped lang="scss">

</style>